<template>
    <div class="add-user">
        <div class="mt-2">
            <div class="input-group imp" data-validation="name">
                <label class="key">Select User:</label>
                <custom-dropdown :list="filteredUsers" :selected="selectedUser" @select="handleUserSelection"
                    @toggle="() => userSearchKeyword = ''" @deselect="handleUserDeselection" :disabled="mode === 'edit'"
                    class="form-template-container-wft">
                    <template #before-items>
                        <div class="fh center py-4" v-if="loadingUsers && users.length === 0">
                            <loading-circle />
                        </div>
                        <!-- <div class="fh center py-4 s" v-else-if="users.length === 0">
                                No Users
                            </div> -->
                        <div class="fh center p-3 form-template-container-wft-search-box" v-else>
                            <input type="text p-2" class="form-template-container-wft-input" v-model="userSearchKeyword"
                                placeholder="Search" />
                        </div>
                        <!-- <div class="fh center py-4" v-if="resources.length !== 0 && filteredUsers.length === 0">
                                No Users
                            </div> -->
                    </template>
                </custom-dropdown>
            </div>
        </div>
        <div class="mt-2">
            <div class="input-group imp" data-validation="name">
                <label class="key">Role:</label>
                <select v-model="selectedRole">
                    <option :value="config.USER_ROLE_MAP.ADMIN">Admin</option>
                    <option :value="config.USER_ROLE_MAP.EDITOR">Editor</option>
                    <option :value="config.USER_ROLE_MAP.VIEWER">Viewer</option>
                    <option :value="config.USER_ROLE_MAP.SUPERVISOR">Supervisor</option>
                </select>
            </div>
        </div>
        <div class="flex-end mt-4 s">
            <button class="btn btn-black mr-3" @click="() => { selectedUser = null; selectedRole = null; }">Cancel</button>
            <button class="btn pointer" @click="addUserToFactory">{{mode === 'create' ? 'Add User' : 'Update Role'}}</button>
        </div>
    </div>
</template>

<script>
import Config from '@/config'
import { mapGetters } from 'vuex'
import CustomDropdown from '@/components/common/customDropdown.vue'
export default {
  name: 'addUser',
  components: { CustomDropdown },
  data () {
    return {
      users: [],
      loadingUsers: false,
      userSearchKeyword: '',
      selectedUser: null,
      selectedRole: null,
      config: Config
    }
  },
  props: {
    factoryUsers: { type: Array, default: () => [] },
    mode: {
      type: String,
      default: 'create'
    },
    selectedUserToEdit: { type: Array, default: () => {} }
  },
  computed: {
    ...mapGetters(['tenantUsersList']),
    filteredUsers () {
      if (this.userSearchKeyword.trim() === '') return this.users
      else {
        return this.users.filter(user => user.name.toLowerCase().includes(this.userSearchKeyword.toLowerCase()))
      }
    }
  },
  mounted () {
    for (const user of this.tenantUsersList) {
      const alreadyAdded = this.factoryUsers.find(factoryUser => factoryUser.id === user.associated_user.id)
      if (user.status === Config.USER_STATUS_MAP.ACTIVE && !alreadyAdded) {
        this.users.push({
          id: user.associated_user.id,
          name: `${user.associated_user.first_name} ${user.associated_user.last_name}`
        })
      }
    }
    if (this.mode === 'edit') {
      this.selectedUser = {
        id: this.selectedUserToEdit.id,
        name: this.selectedUserToEdit.name
      }
      this.selectedRole = this.selectedUserToEdit.role
    }
  },
  methods: {
    handleUserSelection (user) { this.selectedUser = user },
    handleUserDeselection () { this.selectedUser = null },
    addUserToFactory () {
      if (this.mode === 'create') {
        this.$emit('userAdded', { userId: this.selectedUser.id, roleId: this.selectedRole })
      } else {
        this.$emit('changeRole', { userId: this.selectedUser.id, roleId: this.selectedRole })
      }
    },
    cancel () { this.$emit('cancel') }
  }
}
</script>

<style class="scss" scoped>
.add-user {
    min-width: 350px;
}
</style>
